export function numOr0(n) {
    return isNaN(n) ? 0 : n;
}
